// 繁中
module.exports = {
  validate: {
    noEmail: "郵箱不得為空，請重新輸入",
    noPhone: "手機號不得為空，請重新輸入",
    errorReg: "輸入長度為1-50位，可輸入大小寫字母、數字、符號- . _ @",
    noPassword: "密碼不得為空，請重新輸入",
    pwdReg: "密碼輸入長度為8-32位，可輸入數字、字母、特殊字符",
    pwdCheck: "兩次密碼輸入不一致，請重新輸入",
    pwdLengthReg: "密碼長度範圍為8~32，請確認輸入",
    noCode: "請輸入驗證碼",
    codeReg: "請輸入6位數的驗證碼",
    nullText: "輸入不得為空，請重新輸入",
    phoneCheck: "兩次輸入手機號碼不一致，請重新輸入",
    emailNumReg: "郵箱輸入長度為6-50位，請重新輸入",
    emailReg: "郵箱輸入有誤，請重新輸入",
    emailCheck: "兩次輸入郵箱賬號不一致，請重新輸入",
    noUsername: "密碼不能包含賬號，請重新輸入",
    accountReg: "賬號名輸入有誤，請重新輸入",
  },
  area: {
    areaTitle: "區域管理",
    add: "新增區域",
    area: "區域",
    addNextArea: "新建下級區域",
    areaNameTip: "請輸入區域名稱",
    areaNameHold: "輸入長度為1-20位，不可輸入特殊符號",
    areaNumHold: "輸入長度為1-4位，僅限輸入數字，編號範圍0-9999",
    areaNumTip: "請輸入區域編號",
    areaName: "區域名稱",
    checkAreaName: "區域名稱不得為空，請重新輸入",
    areaNameTip1: "區域名稱不得為空",
    areaNameTip2: "區域名稱輸入有誤，請重新輸入",
    areaNum: "區域編號",
    checkAreaNum: "區域編號不得為空，請重新輸入",
    lastLevel: "所屬上級區域",
    checkLastLevel: "所屬上級區域不得為空，請重新選擇",
    lastLevelTip: "請選擇所屬上級區域",
    delInfo: "執行此刪除任務將刪除該區域數據且不可恢復",
    oneStep: "一級",
    twoStep: "二級",
    threeStep: "三級",
    fourStep: "四級",
    fiveStep: "五級",
    delAreaTip: "存在下級區域，不可刪除",
    personArea: "該人員未綁定區域",
    areaType: "新增方式",
    addArea1: "單獨添加",
    addArea2: "連續添加",
    addArea3: "矩陣添加",
    areaNameTop: "區域名稱前綴",
    areaNameLast: "區域名稱後綴",
    areaJoinHold: "請輸入區域名稱前綴",
    areaJoinHold1: "請輸入區域名稱後綴",
    startNum: "起始編號",
    checkStartNum: "起始編號輸入有誤，請重新輸入",
    checkStartNum1: "起始編號輸入不得為空，請重新輸入",
    checkEndNum: "結束編號輸入有誤，請重新輸入",
    checkEndNum1: "結束編號輸入不得為空，請重新輸入",
    endNum: "結束編號",
    topStart: "首部起始編號",
    checkTopStart: "首部起始編號輸入有誤，請重新輸入",
    checkTopStart1: "首部起始編號輸入不得為空，請重新輸入",
    topEnd: "首部結束編號",
    checkTopEnd: "首部結束編號輸入有誤，請重新輸入",
    checkTopEnd1: "首部結束編號輸入不得為空，請重新輸入",
    lastStart: "尾部起始編號",
    checkLastStart: "尾部起始編號輸入有誤，請重新輸入",
    checkLastStart1: "尾部起始編號輸入不得為空，請重新輸入",
    lastEnd: "尾部結束編號",
    checkLastEnd: "尾部結束編號輸入有誤，請重新輸入",
    checkLastEnd1: "尾部結束編號輸入不得為空，請重新輸入",
    topTip: "輸入長度為1-2位，僅限輸入數字，編號範圍1-99",
    lastTip: "輸入長度為1-2位，僅限輸入數字，編號範圍1-99",
    areaNameTest: "區域名稱示例",
  },
  addressBook: {
    config: "工程配置",
    errorTip: "地址簿格式錯誤",
    upgrade: "地址簿升級管理",
    deviceIdTip: "請輸入設備ID",
    deviceId: "設備ID",
    syncAll: "全部同步",
    sync: "同步",
    sysVersion: "當前系統地址簿版本",
    deviceVersion: "當前設備地址簿版本",
    syncTip: "同步指令下發成功",
  },
  newarea: {
    add: "添加區域",
    edit: "編輯區域",
    smallTip: "當前為最小區域層級，不可繼續添加子區域",
    batch: "批量添加區域",
    batch1: "連續添加",
    batch2: "矩陣添加",
  },
  deviceSip: {
    saveTip: "請及時導出地址簿，否則退出頁面後所有的數據將清空。",
    devMsg: "設備信息",
    list: "設備列表",
    add: "添加設備",
    edit: "編輯設備",
    batch: "批量添加設備",
    areaChosen: "區域級別選擇",
    areaNum: "每個區域下新增設備數量",
    bacthTip:
      "當區域級別選擇為棟，每個區域下新增設備數量為4，則表示在已創建的每個棟區域下都新增4個設備",
    note: "說明",
    baseConfig: "基本信息配置",
    deviceName: "設備名稱",
    nameTip: "固定為所屬組名加編號,例如1棟-1",
    function: "設備支持功能",
    net: "網絡配置",
    netType: "網絡類型",
    netTip1: "Static為靜態網絡，需要手動設置IP等信息。",
    netTip2: "DHCP為動態網絡，由路由器自動分配IP等信息。",
    mask: "請輸入子網掩碼",
    gateway: "請輸入網關",
    ip: "請輸入IP地址",
    ipTip: "輸入的IP地址需避開特殊IP，例如127.0.0.1等",
    dns1: "請輸入DNS1",
    dns2: "請輸入DNS2",
    sip1: "sip1信息配置",
    config: "信息配置",
    mode: "模式",
    mode1: "直連模式",
    mode2: "服務器模式",
    user: "請輸入用戶名",
    userTitle: "用戶名",
    userTip: "默認為所述組名加編號,例如1-1-1",
    last: "請輸入賬號後綴",
    sipTip: "請輸入SIP服務器已註冊的用戶名和密碼",
    password: "請輸入密碼",
    passwordTitle: "密碼",
    serverIp: "請輸入serverIP",
    protocolType: "請選擇協議類型",
    protocolTypeTitle: "協議類型",
    sip2: "sip2信息配置",
    more: "更多",
    close: "關閉",
    formatError: "格式錯誤，請重新輸入",
    forbidTip: "禁止輸入127.0.0.1,請重新輸入",
    call: "呼入呼出",
    monitor: "監控",
    lift: "電梯控制",
    rtsp: "rtsp視頻流",
    deviceTip: "設備支持功能不能為空，請重新選擇",
    maskTip1: "子網掩碼不能為空，請重新輸入",
    maskTip2: "子網掩碼格式錯誤,請重新輸入",
    gatewayTip1: "網關不能為空，請重新輸入",
    gatewayTip2: "網關格式錯誤,請重新輸入",
    ipTip1: "IP地址不能為空，請重新輸入",
    ipTip2: "IP地址格式錯誤,上限為255.254.254.253,首段非0,請重新輸入",
    dns1Tip1: "DNS1不能為空，請重新輸入",
    dns1Tip2: "DNS1格式錯誤,請重新輸入",
    dns2Tip1: "DNS2格式錯誤,請重新輸入",
    passwordTip1: "密碼不能為空，請重新輸入",
    serviceTip1: "serviceIp不能為空，請重新輸入",
    serviceTip2: "serviceIp格式錯誤,請重新輸入",
    sip2Tip: "您當前配置了sip2信息，請按規則填寫完整",
    devnameTip1: "設備名稱不能為空，請重新輸入",
    devnameTip2: "設備名稱格式錯誤，請重新輸入",
    nameTip1: "用戶名稱不能為空，請重新選擇",
    nameTip2: "用戶名稱不能為空，請重新選擇",
    maxTip1: "當前區域設備數已達上限8台，不可繼續添加",
    area: "區域",
    editArea: "編輯區域",
    addArea: "添加區域",
    batchArea: "批量添加區域",
    deleteArea: "刪除區域",
    areaName: "區域名稱",
    areaNo: "區域編號",
    importAddr: "導入地址簿",
    next: "下一步",
    areaTip1: "請先選擇需要編輯的區域",
    areaTip2: "請先選擇需要刪除的區域",
    areaTip3: "您當前區域為空，暫不能批量添加設備，請先添加區域信息",
    noArea: "暫無區域配置",
    error: "數據異常",
    addDevice: "添加設備",
    editDevice: "編輯設備",
    delDevice: "刪除設備",
    batchDevice: "批量添加設備",
    prev: "上一步",
    updateAddr: "更新設備地址簿",
    saveAddr: "保存地址簿",
    exportAddr: "導出地址簿",
    deleteTip: "是否刪除設備",
    deleteTip2: "當前選中為區域，請返回區域配置進行刪除",
    deleteTip3: "請先選擇需要刪除的設備",
    deviceTip1: "請先選擇需要編輯的設備",
    deviceTip2: "請先選擇區域，後添加設備",
    exportSuccess: "導出成功",
    xmlTip: "請上傳地址簿的xml文件",
    xmlTip1: "請選擇需要上傳的xml文件",
    xmlTip2: "導入的地址簿與當前小區區域層級不一致，導入失敗",
    areaConfig: "區域配置",
    deviceConfig: "設備配置",
    exportConfig: "預覽導出",
    projectConfig: "項目配置",
    prevArea: "所屬上級區域",
    areaNoTip: "開始編號大於結束編號,請重新填寫",
    smallAreaTip: "當前為最小區域層級，不可繼續添加子區域",
    areaNoTip1: "首部起始編號大於首部結束編號,請重新填寫",
    areaNoTip2: "尾部起始編號大於尾部結束編號,請重新填寫",
  },
  push: {
    list: "推送記錄",
    productType: "產品型號",
    softwareName: "軟件名稱",
    versionNo: "版本號",
    time: "推送時間",
    invalidTime: "失效時間",
    upgrade: "升級",
    upgradeRecord: "查看升級記錄",
    deviceType: "設備類型",
    deviceName: "設備名稱",
    currentSoftName: "當前設備軟件名稱",
    currentSoftNo: "當前設備版本號",
    upgradeNo: "升級軟件版本號",
    filterTip1: "請輸入設備名稱",
    filterTip2: "請選擇軟件名稱",
    filterTip3: "請選擇版本號",
    checkTip: "激活勾選",
    ota: "OTA升級",
    taskName: "任務名稱",
    taskNameTip: "請輸入任務名稱",
    binName: "固件名稱",
    upgradeType: "任務升級方式",
    done: "是否立即執行",
    upgradeTime: "升級時間",
  },
  check: {
    submit: "恭喜您，提交成功!",
    noSubmit: "糟糕，提交失敗!",
    file: "選擇文件",
    noFile: "未選擇任何文件",
    projectName: "項目名稱",
    projectNameTip: "請輸入項目名稱",
    describe: "描述",
    contentTip: "請輸入內容",
    areaType: "區域層級",
    example: "例如：棟-單元-房號",
    areaTip: "區域編號格式錯誤，請重新輸入",
    areaNameTip: "請輸入層級名稱",
    nameTip: "名稱不得為空，請重新輸入",
    nameError: "名稱輸入有誤，請重新輸入",
    nameLength: "名稱輸入長度為4~50，請重新輸入",
    areaNullTip: "區域層級不得為空",
    formateError: "長度為1-6位，不可輸入特殊符號",
    noAreaTip: "區域層級不得為空，請重新選擇",
    maxFileTip: "文件大小超出限制",
    xmlTip: "請上傳XML格式的文件",
  },
  book: {
    areaBy: "所屬區域",
    list: "設備信息重複列表",
    repeatTip:
      "以下設備信息重複，請修改重複的設備信息，點擊“ 確認” 後會判斷設備輸入信息的重複性。",
    coverTip: "本次操作會覆蓋當前選中層級的批量添加數據",
    batchTip: "次批量添加設備生成的IP範圍",
  },
  updateNewSip: {
    otaDeleteTip: "刪除失敗,只能刪除未開始的任務",
    deleteArea1: "是否刪除區域",
    deleteArea2: "同時，該區域以下的所有區域和設備將一併刪除",
    codeRepeatTip: "同層級的區域編號不能重複，請重新輸入當前的區域編號",
    nameRepeatTip: "同層級的區域名稱不能重複，請重新輸入當前的區域名稱",
    deviceIp: "設備IP",
    callin: "呼入",
    callout: "呼出",
    systemMsg: "系統消息",
    batchIpTip: "本次批量添加設備生成的IP範圍",
    ip: "IP地址",
    mask: "子網掩碼",
    gateway: "網關",
    noData: "暫無",
    noAddressTip: "暫無可同步的地址簿數據",
    operator: "操作人",
    goTip: "點擊跳轉對應步驟",
    deviceNameTip: "輸入長度為1-16位，不可輸入特殊符號",
    filter1: "輸入區域名稱進行過濾",
    filter2: "輸入區域名稱或設備名稱進行過濾",
    secret: "加密密碼",
    secretTip: "請輸入32位以內的密碼，格式不限",
    noSecretTip: "未設置加密密碼可忽略",
    setSecret: "設置地址簿加密密碼",
    ignore: "忽略",
    emptyBookTip: "地址簿為空，暫時無法導出",
    errorSecret: "地址簿加密密碼錯誤,請重新輸入",
    other: "其他",
    doorAuth: "門禁",
    funTitle: "請勾選您添加的設備支持的功能",
    callInTip: "設備支持呼叫",
    callOutTip: "設備支持被呼叫",
    monitorTip: "設備支持被監控",
    doorTip: "設備支持開鎖功能",
    liftTip: "設備支持控制電梯",
    maskTip: "請輸入子網掩碼,格式參考：255.255.255.255",
    gatewayTip: "請輸入網關,格式參考：1.1.1.1",
    ip1: "請輸入IP地址,格式參考：1.1.1.1",
    ipTip: "輸入的IP地址需避開特殊IP，例如127.0.0.1等",
    dns1: "請輸入DNS1,格式參考：1.1.1.1",
    dns2: "請輸入DNS2,格式參考：1.1.1.1",
    serverIp: "請輸入serverIp,格式參考：1.1.1.1或域名",
    successxml: "文件解析成功",
    groupCall: "群呼",
    groupCallTip: "開啟後，可通過點擊組呼圖標，同是呼叫組內所有設備",
    record: "版本記錄",
    export: "導出",
    sync: "同步",
    communityTip: "當前存在區域設備數據，禁止切換區域層級",
    areaNameTitle: "層級描述",
    noDataTip: "暫無數據",
    areaCodeDescriptionTip: "層級描述不可空，請填寫完整",
    moduleName: "地址簿配寘工具",
    userSipAccount: "固定為所屬上級組區域編號+設備序號",
    devMax: "設備節點超出10000條限制， 添加失敗",
    areaMax: "區域節點超出10000條限制， 添加失敗",
    ipAndMaskTip1:
      "IP地址與子網掩碼相關聯，需要滿足業務邏輯校驗相與&後結果不全1或不全0",
    ipAndMaskTip2: "當出現業務校驗規則錯誤後，請修改對應的IP地址",
    ipAndMaskTip3: "子網掩碼與IP地址的業務校驗規則錯誤，請修改IP地址",
    ipAndMaskTip4: "批量添加設備時，會自動跳過不滿足業務邏輯校驗的IP",
    correctMaskTip: "請先填寫正確的子網掩碼",
    correctIpTip: "請填寫正確的IP地址",
  },
  newDeviceType: {
    indoorMachine: "室內機",
    doorPhone: "門口機",
    smallDoor: "小門口機",
    manage: "管理機",
    wall: "圍牆機",
    monitor: "網路攝像頭",
    unitGuard: "單元管理機",
    networkCard: "聯網刷卡頭",
    unitCard: "單元刷卡頭",
    lift: "電梯聯動模塊",
    deviceTypeTip: "請選擇設備類型"
    }
};
